<!-- Finder particular de Compañías Sucursales -->
<template> 
  <div class="cias_F" v-if="schema">
    <v-sheet :elevation="4">

      <!-- Cabecera -->
      <div class="cabecera" v-if="Entorno.header.header">       
        <base_Header 
          :Entorno="Entorno.header"
          @onEvent="event_Header">          
        </base_Header>
      </div>

      <!-- Contenido -->
      <div class="contenedor">       
        <div :style="Entorno.filtro.style" :class="Entorno.filtro.class">
          <div style="display:flex; align-items:center">
            <v-row no-gutters>
              <v-col md="7">
                <v-text-field
                  v-bind="$input"
                  v-model="schema.ctrls.cia.value"
                  :label="schema.ctrls.cia.label"
                  @keypress.13="buscarExec('buscarCia')">                
                </v-text-field>
              </v-col>

              <v-col md="1">
                <v-btn v-bind="$cfg.btn.busca" @click="buscarExec('buscarCia')">
                  <v-icon dark>{{ $cfg.btn.busca.icono }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col md="8">
                <ctrlfinder finderName="atlas_F" :schema="schema.ctrls.atlas"></ctrlfinder>
                <ctrlfinder finderName="ciac_F" :schema="schema.ctrls.ciac"></ctrlfinder>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Grid -->
        <base_Fgrid :padre="stName" :Entorno="Entorno" @onEvent="event_Grid">
          <!-- Slot botonera Top -->
          <template v-slot:top_btns="{ Sitem }">         
            <div style="padding:10px 0 0 10px;">
              <btracombi
                :btra_permisos="schema.btra"
                :btra_particular="Entorno.btra"
                btra_modulo="top"
                @onEvent="event_btra_Top({ accion:$event.accion, row:Sitem })">
              </btracombi>
            </div>
          </template>

          <!-- Slot campo acciones del Grid -->
          <template v-slot:acciones_grid="{ Sitem }">
            <btracombi
              :btra_permisos="schema.btra"
              :btra_particular="Entorno.btra"
              btra_modulo="mrow"
              @onEvent="event_btra_Row({ accion:$event.accion, row:Sitem })">
            </btracombi>
          </template>
        </base_Fgrid>
      </div>   
    </v-sheet>
  </div>
</template>



<script>

  import { mixinFinder } from "@/mixins/mixinFinder.js";
  import plugs from "@/common/general_plugs";
  const base_Header = () => plugs.groute("base_Header.vue", "base"); 
  const base_Fgrid = () => plugs.groute("base_Fgrid.vue", "base");
  const btracombi = () => plugs.groute("btracombi.vue", "comp");  
  const ctrlfinder = () => plugs.groute("ctrlfinder.vue", "comp");

  export default {
    mixins: [mixinFinder],
    components: { base_Header, base_Fgrid, btracombi, ctrlfinder },
    props: {
      padre: { type:String, default: ''},
      componenteTipo: { type:String, default:'FM' },
      Entorno: { type: Object, default: function() { return JSON.parse(JSON.stringify(this.$cfg.base.F)); }}
    },

    data() {
      return {
        schema:null,
        api:'cias_F',
        stName:'stFcias',
        component_M:null,
        modal:false,
        accion:'',
        accionRow: {},        
        disparo:false,
        
        headers:{}
      };
    },
  

    methods: {
      ini_data() {
        console.log("DEV " + this.api + " ********************** (ini_data)");
        
        // guardo Schema del store en variable local
        this.schema = this.$store.state[this.stName].schema;

        // configuro Entorno 
        this.Entorno.header.titulo = "Compañias Sucursales";        

        this.headers = {
          header:[
            { text: "Compañía", value: "name", width: "10rem" },
            { text: "Atlas", value: "atlas", width: "10rem" },
            { text: "Clase", value: "situ", width: "10rem" },
            { text: "Acciones", value: "acciones", sortable: false, width: "auto" }
          ]
        };
        
        this.Entorno.grid.headers = this.set_headers();

      },
    }
  };
</script>
